import { AuthProvider, Layout } from '@jobcost-monorepo/ui';
import { ROUTES } from '@jobcost-monorepo/utils';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import {
  ActivitiesPage,
  AutofatturePage,
  BrowseIconsPage,
  CustomersPage,
  DashboardPage,
  FinancialReportPage,
  ReportRsPage,
  ForgotPasswordPage,
  JobsPage,
  NotFoundPage,
  OrderCountersPage,
  OrdersPage,
  OrdersScheduledPage,
  QuickInsertPage,
  ResetPasswordPage,
  ResourceSkillsPage,
  ResourcesPage,
  ScheduledValuesPage,
  SignIn,
  SkillsPage,
  SuppliersPage,
  TimesheetReportGlobalPage,
  TimesheetReportSinglePage,
  TypeOfPaymentsPage,
  UsersPage,
} from '../pages';
import ProtectedRoute from './ProtectedRoute';
import InvoicingFeatureRoute from './InvoicingFeatureRoute';
import GestifyCredentialsPage from '../pages/GestifyCredentials';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />

        <Route element={<AuthProvider />}>
          <Route element={<Layout />}>
            <Route
              path="/"
              element={<Navigate to={ROUTES.TIMESHEET_SINGLE} />}
            />
            <Route
              path={ROUTES.TIMESHEET_SINGLE}
              element={<TimesheetReportSinglePage />}
            />

            <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
              <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
              <Route path={ROUTES.ACTIVITIES} element={<ActivitiesPage />} />
              <Route path={ROUTES.CUSTOMERS} element={<CustomersPage />} />
              <Route
                element={<InvoicingFeatureRoute feature="autofatture" />}
              >
                <Route
                  path={ROUTES.AUTOFATTURE}
                  element={<AutofatturePage />}
                />
              </Route>
              <Route path={ROUTES.QUICK_INSERT} element={<QuickInsertPage />} />
              <Route path={ROUTES.JOBS} element={<JobsPage />} />
              <Route path={ROUTES.ORDERS} element={<OrdersPage />} />
              <Route
                path={ROUTES.FINANCIAL_REPORT}
                element={<FinancialReportPage />}
              />
              <Route
                path={ROUTES.REPORT_RS}
                element={<ReportRsPage />}
              />
              <Route
                path={ROUTES.ORDER_COUNTERS}
                element={<OrderCountersPage />}
              />
              <Route
                element={<InvoicingFeatureRoute feature="gestifyCredentials" />}
              >
                <Route
                  path={ROUTES.GESTIFY_CREDENTIALS}
                  element={<GestifyCredentialsPage />}
                />
              </Route>
              <Route
                path={ROUTES.ORDERS_SCHEDULED}
                element={<OrdersScheduledPage />}
              />
              <Route path={ROUTES.RESOURCES} element={<ResourcesPage />} />
              <Route
                path={ROUTES.RESOURCE_SKILLS}
                element={<ResourceSkillsPage />}
              />
              <Route
                path={ROUTES.SCHEDULED_VALUES}
                element={<ScheduledValuesPage />}
              />
              <Route path={ROUTES.SKILLS} element={<SkillsPage />} />
              <Route path={ROUTES.SUPPLIERS} element={<SuppliersPage />} />
              <Route
                path={ROUTES.TIMESHEETS_REPORT_GLOBAL}
                element={<TimesheetReportGlobalPage />}
              />
              <Route
                path={ROUTES.TYPE_OF_PAYMENTS}
                element={<TypeOfPaymentsPage />}
              />
              <Route path={ROUTES.USERS} element={<UsersPage />} />
              {process.env.NODE_ENV === 'local' && (
                <Route
                  path={ROUTES.BROWSE_ICONS}
                  element={<BrowseIconsPage />}
                />
              )}
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
